import { skipToken } from "@reduxjs/toolkit/query";
import type { FC } from "react";
import { useGetToolQuery } from "../../api/entities/tool.js";
import { renderCrumbLabel } from "../../app/navigation/crumbLabel.js";

interface ToolNameCrumbLabelProps {
  toolId: string | undefined;
}

/** Breadcrumb label for the tool details page. */
export const ToolNameCrumbLabel: FC<ToolNameCrumbLabelProps> = (props) => {
  const { toolId } = props;
  const result = useGetToolQuery(toolId ?? skipToken);
  return renderCrumbLabel({
    hasValidId: toolId !== undefined,
    result,
    buildText: ({ tool }) => tool.name,
    fallbackText: "Tool",
  });
};
